import { z } from 'zod'
import { afterValid } from '~/services/api/contracts/afterValid'
import { email } from '~/services/api/contracts/email'
import { ResetPasswordRequestSchema } from '~/services/api/generated'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const normalize = fieldNormalizer({ always: { trimmed: ['email'] } })

const requestSchema = ResetPasswordRequestSchema.extend({
  email: email(255),
  password_confirmation: z.string().min(1)
}).strict()

// Confirmation only has to match, not independently satisfy the complexity regex.
const matchesPassword = afterValid(requestSchema, (request, context) => {
  if (request.password_confirmation !== request.password) {
    context.addIssue({
      code: 'custom',
      message: 'password_confirmation_mismatch',
      path: ['password']
    })
  }
})

export const PasswordResetReset = (_context: NoContext) => z.preprocess(normalize, matchesPassword)
